import { api } from '../core';

export type CaseCancelPaginationResponse = null;

type CaseCancelPaginationProps = {
  caseId: string;
};

const caseCancelPaginationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseCancelPagination: builder.query<CaseCancelPaginationResponse, CaseCancelPaginationProps>({
      query: ({ caseId }: CaseCancelPaginationProps) => ({
        url: `case/cancel-pagination`,
        method: 'POST',
        body: { caseId }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseRegister in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseCancelPaginationQuery } = caseCancelPaginationApi;
